const Checkbox = ({
  checkClassName,
  name,
  value,
  inputFocus,
  handleChange,
  checked,
  label,
}) => {
  return (
    <div className="form-check position-relative mt-3">
      <input
        id={name}
        className={"form-check-input radio-group getLabel " + checkClassName}
        type="checkbox"
        name={name}
        value={value}
        onInput={inputFocus}
        onChange={handleChange}
        checked={checked}
      />
      <label className="form-check-label" htmlFor={name}>
        {label}
      </label>
      <div className="invalid-tooltip">Veuillez valider les conditions</div>
    </div>
  );
};

export default Checkbox;
